import React, {useEffect, useRef, useState} from 'react'
import {sendData} from '../../../store/actions'
import {useDispatch} from 'react-redux'
import Layout from '../../../components/layout/Layout'
import {useHistory, useParams} from 'react-router-dom'
import * as Icon from 'ubs-icons'
import {isMobileDevice} from '../../../common/functions'
import {createCookie} from 'ubs-framework/v2/common/cookie';
import useSocket from '../../common/useSocket'
import UInput from '../../../common/component/UInput'
import Validator from 'simple-react-validator'
import {useForceUpdate} from '../../common/useForceUpdate'
import UPopup from '../../../common/component/UPopup'
import AppHeader from '../../common/components/app-header'
import Commonrightcircle from '../../../common/component/RightCircle/commonrightcircle'
import {COLOR, constant} from '../../../common/constant'
import {isInApp} from 'ubs-framework/src/common/function'
import {withRouter} from "../../../common/hocs/routing-hoc";


function OnBoardingLogin(props) {
    const dispatch = useDispatch()
    const history = useHistory()
    const { orgId } = useParams()
    const CloseModal = useRef('u_select-place')
    const [errorMsg, setErrorMsg] = useState('')
    const [disabledBtn, setDisabledBtn] = useState(false)
    const [loginDetail, setLoginDetail] = useState({
        email: '',
        password: '',
        orgId,
    })
    const [hide, setHide] = useState(false)
    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: { forceUpdate },
    }))
    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'onboardingLogin':
                    createCookie('ubs_token', res.data.token, constant.COOKIE_DAYS)
                    setDisabledBtn(true);
                    if(res.data.isPreBoarding && props?.projectRoutes?.isPreBoarding){
                        window.location.href = `${process.env.REACT_APP_RECRUIT_MODULE_URL}/${orgId}/boarding-document/${res.data?._id}`
                    }
                    else window.location.href = `${process.env.REACT_APP_HRMS_MODULE_URL}/${orgId}/employee-onboarding/employee-preview/${res.data?._id}`
                    break
                default:
                    return true
            }
        } else {
            setErrorMsg(res.data.error)
            setDisabledBtn(false)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    const onSubmit = (data) => {
        data.preventDefault()
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            sendData(dispatch, 'onboardingLogin', loginDetail)
        } else {
            validator?.current?.showMessages()
        }
    }

    const inputEvent = (e) => {
        let { name, value } = e.target
        value = value.replace(/^\s+/g, '').trim()
        setLoginDetail((val) => {
            return { ...val, [name]: value }
        })
    }

    useEffect(() => {
        refresh()
        return () => off()
    }, [])

    const onKeyUp = e => {
        if (e.key === 'Enter') {
            onSubmit(e)
        }
    }
    useEffect(() => {
        document?.getElementsByClassName('u_account-form').autofocus
    }, [])
    return (
        <React.Fragment>
            <Layout module="on-boarding-login">
                <div className="u_account-form" ref={CloseModal}>
                    <Commonrightcircle/>
                    <AppHeader header="Sign In Your Account" title="Welcome Back! Please Sign In to access Superworks."/>

                    <UInput hasError={validator?.current?.message('email', loginDetail?.email, 'required')}
                            className="u_mb-20" label="Email Address / Employee Code" asterisk>
                        <input onChange={inputEvent} value={loginDetail.email} type="text" onKeyUp={onKeyUp}
                               name="email" placeholder=" "/>
                    </UInput>

                    <UInput className="u_mb-20" password label="Password" asterisk
                            hasError={validator?.current?.message('password', loginDetail?.password, 'required|min:8')}>
                        <input onChange={inputEvent} value={loginDetail.password}
                               type={`${hide ? 'text' : 'password'}`}
                               autoComplete="off"
                               onKeyUp={onKeyUp}
                               name="password"
                               placeholder=" "/>
                        <div className="u_input-note u_ib">
                            <UPopup params={{ className: 'u_tooltip u_tooltip-full', disabled: isMobileDevice() }}
                                    desc={<span>{!hide ? 'Show Password' : 'Hide Password'} </span>}>

                                <span className="u_rollover u_cp u_flex" onClick={() => setHide(!hide)}>{!hide ?
                                    <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                    <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                            </UPopup>
                        </div>
                    </UInput>
                    {errorMsg.length !== 0 && <p className="u_error-message">{errorMsg}</p>}
                    {!isInApp() && <div className="u_forgotpass">
                        <span onClick={() => {
                            history?.push(`${props?.projectRoutes?.forgot}` || `/forgot-password`)
                        }}
                              className="u_forgotpass__link u_cp">Forgot Password?</span>
                    </div>}
                    <div className="u_block u_relative">
                        <button disabled={disabledBtn} type="button" onClick={onSubmit}
                                className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}>Login
                        </button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70}/></div>}
                    </div>
                </div>
            </Layout>
        </React.Fragment>
    )
}

export default withRouter(OnBoardingLogin)
